import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import {
  IPlaintiff,
} from '../../interfaces';

import {
  FormModal,
} from '../../lib/mighty-fields';

import { FunderStoreClass } from '../../stores';

import getFieldSetsPlaintiff from './main-contacts/FieldSets';

interface IProps {
  onClose: () => void;
  onSave: () => void;
  plaintiff: IPlaintiff;
}

interface IInjected extends IProps {
  FunderStore: FunderStoreClass;
}

@inject('FunderStore')
@observer
class PlaintiffInfoModal extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  public render () {
    const {
      onClose,
      onSave,
      plaintiff,
    } = this.props;

    const { FunderStore } = this.injected;

    return (
      <FormModal
        fieldSets={getFieldSetsPlaintiff(FunderStore.canSeeSpanishSpeaking)}
        model={plaintiff}
        onClose={onClose}
        onSave={onSave}
        title='Plaintiff Info'
      />
    );
  }
}

export default PlaintiffInfoModal;
